export default {
  getPermissions: state => state.permissions,
}
